import { toast } from 'sonner';
import { downloadBlob } from '@/lib/uploadFile';

/** Download a file as a Blob and show toast on error. */
export async function safeDownload(filename, originalName, token, t) {
  try {
    await downloadBlob(filename, originalName, token);
  } catch (err) {
    toast.error(err.message || (t ? t('error') : 'Error al descargar'));
  }
}

export function isVideoFile(filename) {
  const ext = filename?.split('.').pop()?.toLowerCase();
  return ['mp4', 'webm', 'avi', 'mov', 'mkv'].includes(ext);
}

export function formatScheduledDate(isoString) {
  if (!isoString) return '';
  const dt = new Date(isoString);
  return dt.toLocaleString('es-ES', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}
